import Dropzone from "dropzone"
import ExifParser from "exif-parser"

import "./uploader.scss"
import dateFormatter from "./date-formatter"

let photoUpload = null
let previewNode = null
let previewTemplate = null

const FIELD_PREFIX = "fc_uploader[photos][]"

const applyToAllChecked = {
  location_name: false,
  descr: false,
  name: false,
  made_at: false,
}

function hideErrorMessage(inputGroup) {
  const errorMsg = inputGroup.querySelector(".error")
  if (errorMsg) {
    errorMsg.classList.add("js-hidden")
  }

  inputGroup.classList.remove("error")
}

function updateCounter(dropzone) {
  if (dropzone.files.length) {
    const uploaded = dropzone.files.filter((f) => f.status === "success").length
    const total = dropzone.options.maxFiles
    $(".photo-upload-count").text(`(${uploaded}/${total})`)
  } else {
    $(".photo-upload-count").text("")
  }
}

function handleApplyToAll(dropzone, preview, field) {
  Array.from(
    photoUpload.querySelectorAll(`.photo-upload__apply-${field}-to-all-field-group`),
  ).forEach((group) => {
    if (dropzone.files.length > 1) {
      group.classList.remove("js-hidden")
      if (applyToAllChecked[field] && preview) {
        preview.querySelector(`.photo-upload__${field}-fields`).classList.add("js-hidden")
      }
    } else {
      group.classList.add("js-hidden")
      const input = group.querySelector("input")
      input.checked = false
      applyToAllChecked[field] = false
    }
  })
}

function toggleLocationFieldGroups(preview, mode) {
  preview.querySelector(`input[name="${FIELD_PREFIX}[location_mode]"]`).setAttribute("value", mode)

  const currentGroup = preview.querySelector(".photo-upload__location-fieldgroup:not(.js-hidden)")
  Array.from(currentGroup.querySelectorAll("input, select")).forEach((el) => {
    /* eslint-disable-next-line no-param-reassign */
    el.value = ""
  })

  Array.from(currentGroup.querySelectorAll("label.error")).forEach((label) => {
    hideErrorMessage(label)
  })

  $(preview).find(".photo-upload__location-fieldgroup").toggleClass("js-hidden")
}

function applyToAll(checkbox, preview) {
  const field = checkbox.dataset.attribute
  const previews = photoUpload.querySelector(".photo-upload__previews")
  applyToAllChecked[field] = checkbox.checked

  Array.from(previews.querySelectorAll(".photo-upload__preview")).forEach((current) => {
    /* eslint-disable no-param-reassign */
    if (current !== preview) {
      if (checkbox.checked) {
        current.querySelector(`.photo-upload__apply-${field}-to-all`).checked = false
        current.querySelector(`.photo-upload__${field}-fields`).classList.add("js-hidden")
      } else {
        current.querySelector(`.photo-upload__${field}-fields`).classList.remove("js-hidden")
      }
    }
    /* eslint-enable no-param-reassign */
  })
}

function copyFieldValueToAll(fieldGroup, field, tag = "input") {
  const selector = `${tag}[name="${FIELD_PREFIX}[${field}]"]`
  const { value } = fieldGroup.querySelector(selector)

  Array.from(photoUpload.querySelectorAll(selector)).forEach((el) => {
    el.value = value
    hideErrorMessage(el.parentNode)
  })
}

function toggleRetryBlock(previewElement, show) {
  const retryBlock = previewElement.querySelector(".photo-upload__retry-block")

  if (show) {
    retryBlock.classList.remove("photo-upload__retry-block--invisible")
  } else {
    retryBlock.classList.add("photo-upload__retry-block--invisible")
  }
}

function setupPreview(file, dropzone, autocomplete_url) {
  const preview = file.previewElement
  const uploadIdInput = preview.querySelector(`input[name="${FIELD_PREFIX}[upload_id]"]`)
  const uploadId = file.upload.uuid
  uploadIdInput.setAttribute("value", uploadId)

  preview.querySelector("#photo_location_id").id = `photo_location_id_${uploadId}`
  preview.querySelector(".dropzone_photo_data").id = `dropzone_photo_data_${uploadId}`

  Array.from(preview.querySelectorAll(".photo-upload__toggle-location-mode")).forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault()
      if (link.classList.contains("photo-upload__toggle-location-mode--disabled")) return

      toggleLocationFieldGroups(preview, link.dataset.mode)
    })
  })

  const copyToAllElements = preview.querySelectorAll(".photo-upload__copy-to-all")
  Array.from(copyToAllElements).forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault()
      const { attribute } = element.dataset

      if ("location_name" === attribute) {
        copyFieldValueToAll(element.parentElement, "location_id")
        copyFieldValueToAll(element.parentElement, "location_name")
      } else if ("descr" === attribute) {
        copyFieldValueToAll(element.parentElement, attribute, "textarea")
      } else {
        copyFieldValueToAll(element.parentElement, attribute)
      }
    })
  })

  const applyToAllElements = preview.querySelectorAll(".photo-upload__apply-to-all")

  applyToAllElements.forEach((el) => {
    el.addEventListener("change", (e) => applyToAll(e.target, preview))
  })

  const locationField = preview.querySelector("#photo_location")
  locationField.id = `photo_location_${uploadId}`
  $(locationField).auto_complete_loc({
    url: autocomplete_url,
    immediate_submit: false,
    loc_id: `photo_location_id_${uploadId}`,
    loading_css_class: "photo-upload__location--loading",
    inactive_color: "inherit",
    container: photoUpload.querySelector(".photo-upload__popup")
      ? photoUpload.querySelector(".photo-upload__previews")
      : document.body,
    callback_on_ready(source) {
      source.classList.remove("photo-upload__location--loading")
    },
  })

  if ($.fn.datetimepicker) {
    $.datetimepicker.setDateFormatter(dateFormatter)
    const time = $(preview.querySelector(".photo-upload__made_at-fields input"))
    const currentMoment = new Date()

    time.datetimepicker({
      maxDate: currentMoment,
      maxTime: currentMoment,
      format: "MMMM Do YYYY, HH:mm",
      formatDate: "MMMM Do YYYY",
      formatTime: "HH:mm",
      step: 10,
      onChangeDateTime(date) {
        if (date && date.getDate() === currentMoment.getDate()) {
          this.setOptions({ maxTime: new Date() })
        } else {
          this.setOptions({ maxTime: false })
        }
      },
    })

    time.blur(() => {
      if ($(this).datetimepicker("getValue") > currentMoment) {
        $(this).datetimepicker("setValue", currentMoment)
      }
    })

    const reader = new FileReader()
    reader.onload = () => {
      try {
        const parser = ExifParser.create(reader.result)
        const exif = parser.parse()
        let timestamp = exif.tags.DateTimeOriginal

        if (timestamp) {
          timestamp += new Date().getTimezoneOffset() * 60
          time.datetimepicker("setOptions", {
            value: new Date(timestamp * 1000),
          })
        }

        const orientation = exif.tags.Orientation
        if (orientation && getComputedStyle(document.body)["imageOrientation"] !== "from-image") {
          preview
            .querySelector(".photo-upload__image-img")
            .classList.add(`photo-upload__image-img--orientation-${orientation}`)
        }
      } catch (e) {
        // continue regardless of error
      }
    }
    reader.readAsArrayBuffer(file)
  }

  Array.from(preview.querySelectorAll('input[type="text"], textarea')).forEach((input) => {
    input.addEventListener("keypress", (e) => {
      const inputGroup = e.currentTarget.parentNode
      hideErrorMessage(inputGroup)
    })
  })

  Array.from(preview.querySelectorAll("select")).forEach((select) => {
    select.addEventListener("change", (e) => {
      const inputGroup = e.currentTarget.parentNode
      hideErrorMessage(inputGroup)
    })
  })

  const retry = preview.querySelector(".photo-upload__retry")
  retry.addEventListener("click", (e) => {
    e.preventDefault()
    toggleRetryBlock(file.previewElement, false)

    if (file.upload.chunked && file.upload.chunks.length > 1) {
      const { chunks } = file.upload
      chunks.pop()

      /* eslint-disable-next-line no-param-reassign */
      file.status = Dropzone.UPLOADING
      const lastChunk = chunks[chunks.length - 1]
      file.upload.finishedChunkUpload(lastChunk)
    } else {
      /* eslint-disable-next-line no-param-reassign */
      file.status = "queued"
      dropzone.processQueue()
    }
  })
}

function hideLocationAutoComplete(uploadId) {
  const autocomplete = document.getElementById(`photo_location_${uploadId}_autocomplete`)
  if (autocomplete) {
    autocomplete.parentNode.removeChild(autocomplete)
  }
}

function scrollPopupIntoViewIfNeeded(element, popup) {
  const previews = popup.querySelector(".photo-upload__previews")
  const visibleStart = $(previews).scrollTop()
  const visibleEnd = visibleStart + previews.offsetHeight

  let { offsetParent } = element.offsetParent
  let offset = offsetParent.offsetTop

  while (offsetParent !== previews) {
    offsetParent = offsetParent.offsetParent
    offset += offsetParent.offsetTop
  }

  if (offset < visibleStart || offset > visibleEnd) {
    $(previews).animate(
      {
        scrollTop: offset - previews.offsetHeight / 8,
      },
      1000,
    )
  }
}

function scrollIntoViewIfNeeded(element) {
  const visibleStart = $(window).scrollTop()
  const visibleEnd = visibleStart + window.innerHeight
  const offset = $(element).offset().top

  if (offset < visibleStart || offset > visibleEnd) {
    $("html, body").animate(
      {
        scrollTop: offset - window.innerHeight / 8,
      },
      1000,
    )
  }
}

function appendFileErrorMessage(file, message) {
  const errorMessage = document.createElement("div")
  errorMessage.classList.add("photo-upload__error")
  const messageNode = document.createTextNode(message)

  if (file) {
    const filename = document.createElement("div")
    filename.classList.add("photo-upload__error-filename")
    filename.innerText = file.name
    errorMessage.appendChild(filename)
  }

  errorMessage.appendChild(messageNode)

  const popup = photoUpload.querySelector(".photo-upload__popup")
  if (popup) {
    const messages = popup.querySelector(".photo-upload__messages")
    messages.classList.remove("photo-upload__messages--hidden")
    messages.insertBefore(errorMessage, messages.firstChild)
  } else {
    const dropzone = photoUpload.querySelector(".photo-upload__dropzone")
    dropzone.parentNode.insertBefore(errorMessage, dropzone.nextSibling)
    errorMessage.addEventListener("click", () => {
      errorMessage.parentNode.removeChild(errorMessage)
    })
  }
}

function toggleUploading(uploading = true) {
  const uploadingMessage = photoUpload.querySelector(".photo-upload__uploading-message")

  if (uploading) {
    uploadingMessage.classList.remove("js-hidden")
  } else {
    uploadingMessage.classList.add("js-hidden")
  }

  const submitButton = photoUpload.querySelector(".photo-upload__submit")
  submitButton.disabled = uploading
}

function appendError(fieldGroup, message) {
  const errorMessage = fieldGroup.querySelector("small")
  if (errorMessage) {
    errorMessage.classList.remove("js-hidden")
    errorMessage.innerText = message
  }

  fieldGroup.querySelector("label").classList.add("error")
}

function appendPhotosErrors(photos) {
  photos.forEach((photo) => {
    Object.keys(photo.errors).forEach((key) => {
      const fieldGroup = photoUpload.querySelector(
        `#dropzone_photo_data_${photo.upload_id} .photo-upload__${key}-fields`,
      )

      appendError(fieldGroup, photo.errors[key])
    })
  })
}

function appendCommonInputError(key, message) {
  const fieldGroup = photoUpload.querySelector(`#row_${key}`)
  appendError(fieldGroup, message)
}

function toggleForm(enabled) {
  Array.from(photoUpload.querySelectorAll("input, textarea, button, select")).forEach((element) => {
    element.disabled = !enabled // eslint-disable-line no-param-reassign
  })

  Array.from(photoUpload.querySelectorAll(".photo-upload__toggle-location-mode")).forEach(
    (element) => {
      if (enabled) {
        element.classList.remove("photo-upload__toggle-location-mode--disabled")
      } else {
        element.classList.add("photo-upload__toggle-location-mode--disabled")
      }
    },
  )
}

function toggleCopyToAllLinks(visible) {
  const applyToAllElementsAll = photoUpload.querySelectorAll(".photo-upload__copy-to-all")

  if (visible) {
    Array.from(applyToAllElementsAll).forEach((el) =>
      el.classList.add("photo-upload__copy-to-all--visible"),
    )
  } else {
    Array.from(applyToAllElementsAll).forEach((el) =>
      el.classList.remove("photo-upload__copy-to-all--visible"),
    )
  }
}

$(() => {
  photoUpload = document.querySelector(".photo-upload")

  previewNode = document.querySelector("#dropzone_template")
  if (previewNode) {
    previewNode.id = ""
    previewTemplate = previewNode.parentNode.innerHTML
    previewNode.parentNode.removeChild(previewNode)
  }

  Dropzone.autoDiscover = false

  const commonFields = photoUpload.querySelector(".photo-upload__common-fields")
  const popupBackdrop = photoUpload.querySelector(".photo-upload__popup-backdrop")
  const popup = photoUpload.querySelector(".photo-upload__popup")

  const { autocomplete_url } = window.FCGON

  let dropzone = null

  ;[...commonFields.querySelectorAll('input[type="text"]')].forEach((input) => {
    input.addEventListener("keypress", (e) => {
      const inputGroup = e.currentTarget.parentNode
      hideErrorMessage(inputGroup)
    })
  })

  const terms = commonFields.querySelector(".photo-upload__terms")
  terms.querySelector('input[type="checkbox"]').addEventListener("change", (e) => {
    if (e.target.checked) {
      terms.querySelector("label").classList.remove("error")
    }
  })

  const dropzoneEl = photoUpload.querySelector(".photo-upload__dropzone")
  $(dropzoneEl).dropzone({
    url: "/photos/upload",
    headers: {
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
    },
    chunking: true,
    retryChunks: true,
    retryChunksLimit: 3,
    chunkSize: 262144,
    acceptedFiles: "image/jpg,image/jpeg,image/png,image/gif,image/pjpeg",
    maxFiles: dropzoneEl.dataset.maxFiles,
    maxFilesize: 20, // MB
    maxThumbnailFilesize: 20, // MB
    thumbnailWidth: 372,
    thumbnailHeight: 372,
    clickable: ".photo-upload__dropzone, .photo-upload__dropzone-info",
    previewTemplate,
    previewsContainer: ".photo-upload__previews",
    dictMaxFilesExceeded:
      "could not be uploaded. Maximum number of photos available to upload at once is {{maxFiles}}.",
    timeout: 120000,

    init() {
      dropzone = this

      this.on("addedfile", (file) => {
        commonFields.classList.remove("js-hidden")
        if (popupBackdrop) {
          popupBackdrop.classList.remove("photo-upload__popup-backdrop--hidden")
        }
        updateCounter(this)

        const firstPreview = photoUpload.querySelector(".photo-upload__preview")
        if (firstPreview !== file.previewElement) {
          firstPreview.parentNode.insertBefore(file.previewElement, firstPreview)
        }
        file.previewElement.classList.remove("js-hidden")

        const messages = photoUpload.querySelector(".photo-upload__messages")
        messages.classList.add("photo-upload__messages--hidden")

        messages.querySelector(".photo-upload__success").classList.add("js-hidden")

        Array.from(messages.querySelectorAll(".photo-upload__error")).forEach((error) => {
          error.parentNode.removeChild(error)
        })

        if (this.files.length === this.options.maxFiles) {
          $(".photo-uploadtatn_dropzone").addClass("js-hidden")
        }

        if (this.files.length > 1) {
          toggleCopyToAllLinks(true)
        }

        Object.keys(applyToAllChecked).forEach((field) => {
          handleApplyToAll(dropzone, file.previewElement, field)
        })

        setupPreview(file, dropzone, autocomplete_url)
      })

      this.on("removedfile", (file) => {
        const preview = file.previewElement
        const uploadId = preview.querySelector(`input[name="${FIELD_PREFIX}[upload_id]"]`).value
        hideLocationAutoComplete(uploadId)

        const applyToAllElements = preview.querySelectorAll(".photo-upload__apply-to-all")
        applyToAllElements.forEach((el) => {
          if (el.checked) {
            el.checked = false
            applyToAll(el, preview)
          }

          handleApplyToAll(dropzone, file.previewElement, el.dataset.attribute)
        })

        updateCounter(this)

        if (this.files.length === 0) {
          if (popupBackdrop && photoUpload.querySelector(".photo-upload__messages--hidden")) {
            popupBackdrop.classList.add("photo-upload__popup-backdrop--hidden")
          }
          commonFields.classList.add("js-hidden")
        } else if (this.files.length < this.options.maxFiles) {
          $(".photo-upload__dropzone").removeClass("js-hidden")
        }

        if (this.files.length < 2) {
          toggleCopyToAllLinks(false)
        }
      })

      this.on("error", (file, message, xhr) => {
        // connection lost
        if (xhr && xhr.status === 0) {
          toggleRetryBlock(file.previewElement, true)
          return
        }

        if (xhr) {
          /* eslint-disable no-param-reassign */
          message = "Failed to upload, please try again later."
          message += ` (Server Response Code: ${xhr.status})`
          /* eslint-enable no-param-reassign */
        }
        appendFileErrorMessage(file, message)
        this.removeFile(file)
      })

      this.on("sending", (file, xhr) => {
        toggleUploading(true)

        const XHR = xhr
        XHR.ontimeout = () => {
          toggleRetryBlock(file.previewElement, true)
        }
      })

      this.on("complete", () => {
        if (this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) {
          toggleUploading(false)
        }
      })
    },

    uploadprogress(file, progress) {
      if (
        file.upload.chunked &&
        progress === 100 &&
        file.upload.chunks.length < file.upload.totalChunkCount
      )
        return

      const preview = file.previewElement
      const bar = preview.querySelector(".photo-upload__progress-completed")
      bar.style.width = `${progress}%`

      if (
        (!file.upload.chunked && progress === 100) ||
        (file.upload.chunked &&
          progress === 100 &&
          file.upload.chunks.length === file.upload.totalChunkCount)
      ) {
        const el = preview.querySelector(".photo-upload__progress")
        el.classList.add("photo-upload__progress--complete")
      }
    },

    success(data, resp) {
      commonFields.classList.remove("js-hidden")
      // resp is empty for some reason, if file was chunked
      const photoId = resp !== "" ? resp.id : JSON.parse(data.xhr.response).id
      const preview = data.previewElement
      const input = preview.querySelector(`input[name="${FIELD_PREFIX}[temp_id]"]`)
      input.setAttribute("value", photoId)

      updateCounter(this)
    },

    maxfilesexceeded(file) {
      $(".photo-upload__dropzone").addClass("js-hidden")
      this.removeFile(file)
    },

    params: function params(files, xhr, chunk) {
      if (chunk) {
        return {
          upload_id: chunk.file.upload.uuid,
          chunk_index: chunk.index,
          total_chunks: chunk.file.upload.totalChunkCount,
        }
      }

      // we send only one file per request
      return { upload_id: files[0].upload.uuid }
    },
  })

  if (popupBackdrop) {
    const close = () => {
      popupBackdrop.classList.add("photo-upload__popup-backdrop--hidden")
      dropzone.removeAllFiles(true)
    }

    popupBackdrop.addEventListener("click", (e) => {
      const popupCloseButton = popupBackdrop.querySelector(".photo-upload__popup-close")
      if (e.target === popupBackdrop || e.target === popupCloseButton) {
        close()
      }
    })

    photoUpload.querySelector(".photo-upload__close-button").addEventListener("click", close)
  }

  const uploadButton = $(".photo-upload__submit")
  let isUploading = false

  uploadButton.click((e) => {
    e.preventDefault()
    if (isUploading) return

    Array.from(photoUpload.querySelectorAll(".photo-upload__error")).forEach((error) => {
      error.parentNode.removeChild(error)
    })

    dropzoneEl.classList.add("js-hidden")

    isUploading = true
    uploadButton.attr({ value: "Saving...", disabled: true })
    $("small.error").addClass("js-hidden")
    $(".row label").removeClass("error")

    $.ajax({
      type: "POST",
      url: "/photos",
      data: $(".photo-upload form").serialize(),
      beforeSend: () => toggleForm(false),
    })
      .always(() => {
        isUploading = false
        toggleForm(true)
        uploadButton.attr({ value: "Save", disabled: false })

        if (dropzone.files.length < dropzone.options.maxFiles) {
          dropzoneEl.classList.remove("js-hidden")
        }
      })
      .done(() => {
        photoUpload
          .querySelector(".photo-upload__messages")
          .classList.remove("photo-upload__messages--hidden")

        const successMessage = photoUpload.querySelector(".photo-upload__success")
        successMessage.classList.remove("js-hidden")

        dropzone.removeAllFiles()

        if (!popup) {
          scrollIntoViewIfNeeded(successMessage)
        }
      })
      .fail((xhr) => {
        if (xhr.status === 422) {
          const data = xhr.responseJSON ? xhr.responseJSON : JSON.parse(xhr.responseText)

          Object.keys(data.errors).forEach((key) => {
            if (key === "photos") {
              appendPhotosErrors(data.errors.photos)
            } else if (key === "upload_id" || key === "temp_id") {
              let message = "Upload failed, please try again later."
              message += `(Server Response Code: ${xhr.status})`
              appendFileErrorMessage(null, message)
            } else {
              appendCommonInputError(key, data.errors[key])
            }
          })

          const errorMessage = photoUpload.querySelector(".photo-upload label.error")
          if (popup) {
            scrollPopupIntoViewIfNeeded(errorMessage, popup)
          } else {
            scrollIntoViewIfNeeded(errorMessage)
          }
        } else {
          let message = "Failed to upload, please try again later."
          message += ` (Server Response Code: ${xhr.status})`
          appendFileErrorMessage(null, message)
        }
      })
  })
})
